<template>
  <div
    class="bg-action-danger-hi rounded-lg my-16 px-32 py-16 text-center text-[white]"
  >
    placeholder for component: <span class="heading-2"> "{{ name }}" </span>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'

const { name } = defineProps<{ name: string }>()

onMounted(() => {
  // eslint-disable-next-line no-console
  console.log(`This component needs to be migrated: ${name}`)
})
</script>
